/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-06-29T16:17:47.697
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportFinancialRentContractItemPaymentCollection,
	getReportFinancialRentContractItemPaymentCollectionCreateInit,
	getReportFinancialRentContractItemPaymentCollectionEditInit,
	getReportFinancialRentContractItemPaymentCollectionView,
	deleteReportFinancialRentContractItemPaymentCollection
} from '@api/report/ReportFinancialRentContractItemPaymentCollection';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportFinancialRentContractItemPaymentCollectionCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialRentContractItemPaymentCollectionCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportFinancialRentContractItemPaymentCollectionEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialRentContractItemPaymentCollectionEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportFinancialRentContractItemPaymentCollection({}, ReportFinancialRentContractItemPaymentCollection) {
			return new Promise((resolve, reject) => {
				saveReportFinancialRentContractItemPaymentCollection(ReportFinancialRentContractItemPaymentCollection)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportFinancialRentContractItemPaymentCollectionView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportFinancialRentContractItemPaymentCollectionView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportFinancialRentContractItemPaymentCollection({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialRentContractItemPaymentCollection({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
